import { ADD_DNO_ITEMS_FAILURE, ADD_DNO_ITEMS_REQUEST, ADD_DNO_ITEMS_RESET, ADD_DNO_ITEMS_SUCCESS } from "redux/actions/action-type"


const initialState = {
    isAddDNOLoading: false,
    isAddDNOSuccess: false,
    isAddDNOFail: false,
    addDNOResponse: {}
}

export const addDoNotOrderItemsReducer = (state = initialState, { type, addDNOResponse }) => {
    switch (type) {
        case ADD_DNO_ITEMS_REQUEST:
            return {
                ...state,
                isAddDNOLoading: true,
                isAddDNOSuccess: false,
                isAddDNOFail: false
            }
        case ADD_DNO_ITEMS_SUCCESS:
            return {
                ...state,
                addDNOResponse: addDNOResponse,
                isAddDNOLoading: false,
                isAddDNOSuccess: true,
                isAddDNOFail: false
            }
        case ADD_DNO_ITEMS_FAILURE:
            return {
                ...state,
                addDNOResponse: addDNOResponse,
                isAddDNOLoading: false,
                isAddDNOSuccess: false,
                isAddDNOFail: true
            }
        case ADD_DNO_ITEMS_RESET:
            return {
                ...initialState
            }
        default:
            return {
                ...state
            }
    }
}